import moment from 'moment'
import api from '@/api'
import { formatDatetime } from '@/utils/dates.js'
import APIUrls from '@/config/simpliciti-apis.js'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async sendMessageToVehicle(
      { commit },
      { vehicleId, message, predefinedMessageId }
    ) {
      let query
      // If there's a message (edited or custom), use that
      if (message) {
        query = `message=${message}`
      }
      // Otherwise if there's a predefined message ID, use that
      else if (predefinedMessageId) {
        query = `message_predefini_id=${predefinedMessageId}`
      } else {
        query = 'message=' // empty message as fallback
      }

      await api.v2.post(
        `/v2/message/send_to_vehicule?vehicule_id=${vehicleId}&${query}`
      )
    },
    async getPredefinedVehiclesMessages() {
      return (await api.v2.get(APIUrls.APIV2_MESSAGE_PREDEFINI_GET)).data
    },
    async getVehicleMessages(
      { commit },
      { vehicleId, datetimeFrom, datetimeTo } = {}
    ) {
      let from = (datetimeFrom && moment(datetimeFrom)) || moment()
      let to = (datetimeTo && moment(datetimeTo)) || moment()
      from = from.format('YYYY-MM-DD HH:mm:ss')
      to = to.format('YYYY-MM-DD HH:mm:ss')
      const url = `/v2/message/get_by_vehicule?vehicule_id=${vehicleId}&dateheure_debut=${from}&dateheure_fin=${to}
      `
      let res = (await api.v2.get(url)).data || []
      res = res instanceof Array ? res : []
      if (!(res instanceof Array)) {
        console.error('getVehicleMessages', {
          err: {
            requestURL: url,
            error: 'getVehicleMessages: Invalid response',
          },
        })
      }

      return res
        .sort(sortByDate)
        .reverse()
        .map((item) => {
          item.dateheure_envoi = formatDatetime(item.dateheure_envoi)
          return item
        })
    },
  },
}

function sortByDate(a, b) {
  return moment(a.dateheure_envoi)._d.getTime() >
    moment(b.dateheure_envoi)._d.getTime()
    ? -1
    : 1
}
